module.exports = __webpack_public_path__ + "img/fukuyamajyou_title11.22ac0c95.jpg";